import styled from 'styled-components'

export const SpecsContent = styled.div`
  width: 100%;
  padding: 15px;
  h2 {
    padding-top: 40px !important;
    font-size: 20px;
    font-family: ${props => props.theme.font.family.bold};
    color: black;
  }

  ul {
    width: 100%;
    margin-top: 22px;
    list-style: none;
    li {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      border-bottom: 1px solid #EAEAEA;
      padding: 4px 5px;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #1A2738;
        text-align: center;
      }
    }
  }
  @media screen and (min-width: 1100px) {
    ul {
      li {
        grid-template-columns: 2fr 7fr;
      }
    }
  }
`
